// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimForApprovalContributions from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-contributions';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import RadioButtonList from '../../../shared/components/radio-button-list/radio-button-list';
import {buildCurrency} from '../../../shared/services/build-number';

const radioButtonItems = new KeyValuePairCollection([
    {
        key: 'CURRENT',
        value: 'CURRENT_VALUES'
    },
    {
        key: 'CUSTOM',
        value: 'CUSTOM_VALUES'
    }
]);

const currentSelectedClass = selected => selected === 'CURRENT' ? 'selected' : '';

const customSelectedClass = selected => selected === 'CUSTOM' ? 'selected' : '';

function handleSelectedContributionChange(radioIndex) {

    this.onSelectedContributionChange(radioButtonItems[radioIndex]);

}

const ValuesToApprove = props => {

    const currentClassName = currentSelectedClass(props.selectedContribution.key);
    const customClassName = customSelectedClass(props.selectedContribution.key);

    return (
        <section className='values-to-approve'>
            <header>
                <FormattedMessage id='SELECT_VALUES_TO_APPROVE'/>
                <RadioButtonList
                    items={radioButtonItems}
                    onItemsUpdate={props::handleSelectedContributionChange}
                    selectedKey={props.selectedContribution.key}
                />
            </header>
            <section className='data'>
                <ul className='customer-row'>
                    <li>
                        <FormattedMessage id='CUSTOMER'/>
                    </li>
                    <li className={currentClassName}>
                        {buildCurrency(props.current.customer)}
                    </li>
                    <li className={customClassName}>

                        <FormattedNumberInput
                            allowNegative={false}
                            decimalPrecision={2}
                            onValueChange={props.onCustomContributionChange.bind(null, 'customer')}
                            value={props.custom.customer}
                        />

                    </li>
                </ul>
                <ul className='dealer-row'>
                    <li>
                        <FormattedMessage id='DEALER'/>
                    </li>
                    <li className={currentClassName}>
                        {buildCurrency(props.current.dealer)}
                    </li>
                    <li className={customClassName}>
                        <FormattedNumberInput
                            allowNegative={false}
                            decimalPrecision={2}
                            onValueChange={props.onCustomContributionChange.bind(null, 'dealer')}
                            value={props.custom.dealer}
                        />
                    </li>
                </ul>
                <ul className='company-row'>
                    <li>
                        <FormattedMessage id='COMPANY'/>
                    </li>
                    <li className={currentClassName}>
                        {buildCurrency(props.current.company)}
                    </li>
                    <li className={customClassName}>
                        <FormattedNumberInput
                            allowNegative={false}
                            decimalPrecision={2}
                            onValueChange={props.onCustomContributionChange.bind(null, 'company')}
                            value={props.custom.company}
                        />
                    </li>
                </ul>
                <ul className='total-row'>
                    <li>
                        <FormattedMessage id='TOTAL'/>
                    </li>
                    <li className={currentClassName}>
                        {buildCurrency(props.current.total)}
                    </li>
                    <li className={customClassName}>
                        {buildCurrency(props.custom.total)}
                    </li>
                </ul>
            </section>
        </section>
    );

};

ValuesToApprove.displayName = 'ValuesToApprove';
ValuesToApprove.propTypes = {
    current: PropTypes.instanceOf(ClaimForApprovalContributions).isRequired,
    custom: PropTypes.instanceOf(ClaimForApprovalContributions).isRequired,
    onCustomContributionChange: PropTypes.func.isRequired,
    onSelectedContributionChange: PropTypes.func.isRequired,
    selectedContribution: PropTypes.instanceOf(KeyValuePair).isRequired
};

export default ValuesToApprove;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/values-to-approve.js